import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import useFirebaseAuthMonitor from './hooks/useFirebaseAuthMonitor';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import SubHeader from './components/SubHeader';

const App = () => {
  useFirebaseAuthMonitor();

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-17715005844";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17715005844');
    `;
    document.head.appendChild(script2);
  }, []);

  return (
    <>
      <Header/>
      <SubHeader/>
      <main className='py-3'>
        <Container>
          <Outlet/>
          <ScrollRestoration/>
        </Container>
      </main>
      <Footer/>
      <ToastContainer/>
    </>
  )
}

export default App